import React from "react";
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./Footer.css";
import CLINIC_CONFIG from '../../../config/clinicConfig';
import CallbackForm from './CallbackForm';
import SocialFollow from './SocialFollow';
import MembershipSection from './MembershipSection';
import ContactInfo from './ContactInfo';

// === Footer Component ===
const Footer: React.FC = () => (
  <>
    <footer className="footer-wrapper">
      {/* ── Membership Band ── */}
      <MembershipSection />

      {/* ── Two-Column Grid: Form + Contact ── */}
      <div className="footer-grid-wrapper">
        <section className="footer-grid">
          <div className="footer-col footer-col--form">
            <CallbackForm />
          </div>
          <div className="footer-col footer-col--contact">
            <ContactInfo />
            <SocialFollow />
          </div>
        </section>
      </div>

      {/* ── Copyright Bar ── */}
      <div className="copyright-bar">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center py-3">
          <span className="text-muted small">
            &copy; {new Date().getFullYear()} {CLINIC_CONFIG.clinicName}. All Rights Reserved.
          </span>
          <div className="d-flex gap-3 mt-2 mt-md-0">
            <Link to="/privacy-policy" className="text-muted small text-decoration-none copyright-link">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-muted small text-decoration-none copyright-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>

    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Dentist",
          "@id": CLINIC_CONFIG.clinicUrl + "/#dentist",
          "name": CLINIC_CONFIG.clinicName,
          "image": CLINIC_CONFIG.clinicUrl + "/images/logo.webp",
          "url": CLINIC_CONFIG.clinicUrl,
          "telephone": CLINIC_CONFIG.phoneNumber,
          "email": CLINIC_CONFIG.email,
          "priceRange": "$$",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": CLINIC_CONFIG.addressShort.split(',')[0].trim(),
            "addressLocality": CLINIC_CONFIG.city,
            "addressRegion": CLINIC_CONFIG.stateShortForm,
            "postalCode": CLINIC_CONFIG.PostalCode,
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 35.464846,
            "longitude": -80.589717
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "18:00"
            }
          ],
          "sameAs": [
            CLINIC_CONFIG.social.facebook,
            CLINIC_CONFIG.social.instagram,
            CLINIC_CONFIG.social.linkedin,
            CLINIC_CONFIG.social.youtube,
            CLINIC_CONFIG.social.twitter
          ]
        })
      }}
    />
  </>
);

export default Footer;
